import {ColumnType} from './columnType';

export class TableColumn {
    // permet uniquement de spécifier un id/name à l'élément HTML de la colonne
    private _name: string;
    public get name(): string {
        return this._name;
    }
    public set name(value: string) {
        this._name = value;
    }

    // Ce paramètre permet de définir si la colonne est exportable ou non
    private _type: ColumnType = ColumnType.TEXT;
    public get type(): ColumnType {
        return this._type;
    }
    public set type(value: ColumnType) {
        this._type = value;
    }

    // doit être identique aux noms des propriétés des objets de cette liste afin de faire un mapping automatique
    private _propertyName: string;
    public get propertyName(): string {
        return this._propertyName;
    }
    public set propertyName(value: string) {
        this._propertyName = value;
    }

    // permet d'afficher un contenu par défaut
    // lorsqu'il n'y a pas de données dans la propriété de l'objet mappé automatiquement
    private _defaultContent: string = null;
    public get defaultContent(): string {
        return this._defaultContent;
    }
    public set defaultContent(value: string) {
        this._defaultContent = value;
    }

    // permet de spécifier une classe CSS passé à la colonne directement
    // (notamment utile pour paramétrer les largeurs de colonnes via des classes Bootstrap)
    private _cssClass: string;
    public get cssClass(): string {
        return this._cssClass;
    }
    public set cssClass(value: string) {
        this._cssClass = value;
    }

    // permet de décider si la colonne est triable ou non
    private _orderable = false;
    public get orderable() {
        return this._orderable;
    }
    public set orderable(value) {
        this._orderable = value;
    }

    // permet de rendre visible ou non une colonne
    // Toutes les colonnes n'ont pas la nécessité d'être montrées à l'utilisateur,
    // ce flag est notamment utile lorsque l'on effectue un export.
    private _visible = true;
    public get visible() {
        return this._visible;
    }
    public set visible(value) {
        this._visible = value;
    }

    private _exportable = true;
    public get exportable(): boolean {
        return this._exportable;
    }
    public set exportable(value: boolean) {
        this._exportable = value;
    }

    private _nestedProperty?: string;
    public get nestedProperty(): string {
        return this._nestedProperty;
    }
    public set nestedProperty(value: string) {
        this._nestedProperty = value;
    }

    private _displayed?: boolean;
    public get displayed(): boolean {
        return this._displayed;
    }
    public set displayed(value: boolean) {
        this._displayed = value;
    }

    constructor($name: string, $propertyName: string, $defaultContent: string,
                $cssClass: string, $type: ColumnType, $nestedProperty?: string, $displayed: boolean = true) {
        this.name = $name;
        this.propertyName = $propertyName;
        this.defaultContent = $defaultContent;
        this.cssClass = $cssClass;
        this.type = $type;
        if (!!$nestedProperty) {
            this.nestedProperty = $nestedProperty;
        }
        this.displayed = $displayed;
    }
}
